const noop = () => { };

if (typeof window !== 'undefined') {
    const methods = ['log', 'debug', 'info', 'warn', 'error'];

    methods.forEach((method) => {
        try {
            (window.console as any)[method] = noop;
        } catch { 
            // handle error
        }
    });
}
